import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import HouseIcon from '../../../../icons/icon-house.svg';
import StorefrontIcon from '../../../../icons/icon-storefront.svg';
import Button from '../Button';
import SectionForm from './SectionForm';


const iconMap = {
  house: HouseIcon,
  storefront: StorefrontIcon,
};

class MultiSectionLookupForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      canSubmit: true,
      editingActive: false,
    };
    this.updateEditingStatus = this.updateEditingStatus.bind(this);
    this.handleSelection = this.handleSelection.bind(this);
    this.editActive = this.editActive.bind(this);
  }

  updateEditingStatus(status) {
    const { editingActive } = this.state;

    if (!editingActive) {
      this.setState({ canSubmit: !status });
    }
  }

  editActive() {
    this.setState({ canSubmit: false, editingActive: true });
  }

  handleSelection(sectionId, value) {
    const {
      programOptions,
      content: { notFoundErrorMessage },
      updateFormValues,
    } = this.props;

    const matchingProgram = programOptions.reduce((found, program) => {
      if (
        found ||
        program.sectionId !== sectionId ||
        program.optionValues.indexOf(value) === -1
      ) {
        return found;
      }

      return program;
    }, null);

    if (!matchingProgram) {
      return notFoundErrorMessage;
    }

    updateFormValues({ location: matchingProgram });

    this.setState({
      canSubmit: true,
      editingActive: false,
    });

    return null;
  }

  render() {
    const {
      content,
      sectionOptions,
      formValues,
      submitForm,
    } = this.props;
    const { ctaButtonLabel } = content;
    const { canSubmit, editingActive } = this.state;
    const buttonClassNames = classNames('opco-nav-form__button', { 'opco-nav-form__button--disabled': !canSubmit });
    const uniqueId = `opco-nav-form__section--${uuid()}`;

    return (
      <>
        <div className="opco-nav-form__container-sections">
          <div className="opco-nav-form__container-label">{content.label}</div>
          {sectionOptions.map((section, idx) => {
            const Icon = iconMap[section.icon];
            const active = editingActive || formValues.location.sectionId !== section.id;

            return (
              <React.Fragment key={section.id}>
                <div className="opco-nav-form__section-title" id={uniqueId}>
                  <Icon className="opco-nav-form__section-icon" />
                  {section.label}
                </div>
                <SectionForm
                  {...section}
                  active={active}
                  value={formValues.location.display}
                  updateEditingStatus={this.updateEditingStatus}
                  editActive={this.editActive}
                  submit={this.handleSelection}
                  inputDescribedBy={uniqueId}
                />
                {idx < sectionOptions.length - 1 && (
                  <div className="opco-nav-form__section-separator">
                    <span className="opco-nav-form__section-separator-text">or</span>
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
        <Button
          className={buttonClassNames}
          eventAction={() => canSubmit && submitForm()}
          label={ctaButtonLabel}
        />
      </>
    );
  }
}

MultiSectionLookupForm.propTypes = {
  content: PropTypes.shape({
    ctaButtonLabel: PropTypes.string,
    label: PropTypes.string,
    notFoundErrorMessage: PropTypes.string,
  }).isRequired,
  sectionOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  programOptions: PropTypes.arrayOf(PropTypes.shape({
    sectionId: PropTypes.string,
    optionValues: PropTypes.arrayOf(PropTypes.string),
  })).isRequired,
  formValues: PropTypes.shape({
    location: PropTypes.shape({
      sectionId: PropTypes.string,
      display: PropTypes.string,
    }),
  }).isRequired,
  updateFormValues: PropTypes.func.isRequired,
  submitForm: PropTypes.func.isRequired,
};

export default MultiSectionLookupForm;
